module.exports = __webpack_public_path__ + "static/img/Compressor.21d30f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/editor/Device/Compressor.png
// module id = zsh6
// module chunks = 3